import { Dispatch, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import Icon from './Icon';
import Button from './Button';

export type GroupUpdateModalProps = {
  children: JSX.Element;
  open: boolean;
  setOpen: Dispatch<boolean>;
};

export default function GroupUpdateModal({
  children,
  open,
  setOpen,
}: GroupUpdateModalProps) {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-40" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex w-full h-full items-start bg-white dark:bg-slate-800">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="transition-all w-full h-full relative transform overflow-hidden text-gray-900 dark:text-white bg-white dark:bg-slate-900">
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
